module.exports = __webpack_public_path__ + "img/join.2398ba64.svg";